import React, { useEffect, useRef, useState } from "react";
import * as XLSX from "xlsx";
import { Button } from "../../Components/Helper";
import Modal from "../../ReusableComponents/Modal";
import TableView from "../../ReusableComponents/TableView/TableView";
import { createBulkCrmleads } from "../../apis/BhuMeetTeams/Crm/leads";
import Popup from "../../ReusableFunctions/Popup";
import FileUploader from "../../ReusableComponents/FileUploader";
import { ExcelValidationForm } from "./excelValidationForm";
import { ExcelvalueEditor } from "./excelValueEditor";
import DragExcelUploader from "../../ReusableFunctions/DragFileUploader";
import { ReactComponent as INFO } from '../../assets/info.svg'


function arraysEqual(arr1, arr2) {
    // console.log(arr1,arr2)
    return arr2.every(value => arr1.includes(value));
}


function paginateData(data, page, pageSize) {
    const startIndex = (page - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    return data.slice(startIndex, endIndex);
}


const ExcelUploader = ({ open, close }) => {
    const [data, setData] = useState([]);
    const [paginatedData, setpaginatedData] = useState([]);
    const [columns, setColumns] = useState([]);
    const [selectedColumns, setSelectedColumns] = useState({});
    const [renamedColumns, setRenamedColumns] = useState([]);
    const [refresh, setRefresh] = useState(0);
    const [orderBy, setOrderBy] = useState("");
    const [orderType, setOrderType] = useState("asc");
    const [page, setPage] = useState(1);
    const [columnspresent, setcolumnPresent] = useState(false)
    const ProfilePicRef = useRef(null);
    const [selectedFile, setSelectedFile] = useState()
    const [isAdding, setIsAdding] = useState(false)
    const [showData, setShowData] = useState(false)
    const [showTableData, setShowTableData] = useState(false)
    const [uploadStatus,setuploadStatus] = useState({})
    const [invalidCount,setInvalidCount] = useState(0)


    const splitArrayIntoChunks = (arr, chunkCount)=> {
        const result = [];

        for (let i = 0; i < arr.length; i += chunkCount) {
            result.push(arr.slice(i, i + chunkCount));
        }

        return result;
      }


    const handleFileUpload = (file) => {
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (event) => {
            const binaryStr = event.target.result;
            const workbook = XLSX.read(binaryStr, { type: "binary" });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];

            const parsedData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
            if (parsedData.length > 0) {
                const headers = parsedData[0];
                // console.log(headers)
                // if (arraysEqual(headers, ['Name', 'Phone'])) setcolumnPresent(false)
                // else {


                //     setcolumnPresent(true)
                //     Popup.alert("ERROR", "Mandatory Fields are missing (Name,Phone)", "ERROR")
                //     return close()
                // }

                const cols = headers.map((header) => ({
                    accessor: header,
                    Header: header,
                }));
                setColumns(cols);
                setSelectedColumns(Object.fromEntries(headers.map((col) => [col, true])));
                setRenamedColumns(headers);

                const dataObjects = parsedData.slice(1).map((row) => {
                    const obj = {};
                    headers.forEach((header, index) => {
                        obj[header] = row[index];
                    });
                    return obj;
                });

                setData(dataObjects);

            }
        };
        reader.readAsBinaryString(file);
    };






    useEffect(() => {
        setSelectedColumns(Object.fromEntries(renamedColumns.map((col) => [col, true])));

        // if (arraysEqual(renamedColumns, ['Name', 'Phone'])) setcolumnPresent(false)
        // else setcolumnPresent(true)
    }, [renamedColumns])

    const sortedData = [...data].sort((a, b) => {
        if (!orderBy) return 0;
        const colIndex = columns.findIndex((col) => col.accessor === orderBy);
        if (colIndex === -1) return 0;
        const aVal = a[colIndex];
        const bVal = b[colIndex];
        return orderType === "asc" ? (aVal > bVal ? 1 : -1) : (aVal < bVal ? 1 : -1);
    });



    const handleSubmit = async () => {
        try {
            setIsAdding(true)
            const selectedKeys = Object.keys(selectedColumns).filter((key) => selectedColumns[key]);
            const finalData = sortedData.map((row) =>
                selectedKeys.reduce((acc, key) => {
                    acc[renamedColumns[key] || key] = row[key];
                    return acc;
                }, {})
            );

            let splitData = splitArrayIntoChunks(finalData,100)
                        setuploadStatus({
                            dataSize:finalData.length
                        
                        })
                        for(let i=0;i<=splitData.length;i++){    
                            setuploadStatus((prev)=>({...prev,currentCount:uploadStatus.currentCount ? uploadStatus.currentCount + splitData[i].length : splitData[i].length }))
                            if(splitData[i]){
                                const res = await createBulkCrmleads(JSON.stringify(splitData[i]))

            
                            }
                        }
                        setIsAdding(false)
                        close(finalData)

            setIsAdding(false)
            close(finalData)
            return Popup.alert("File Imported !", "Your file has been successfully imported.", "SUCCESS")
        } catch (e) {
            console.error(e)
            Popup.alert("SUCCESS", "Something went wrong", "ERROR")
        }



        // alert("Data submitted! Check console for output.");
    };


    const handleExcelColumnValidation = (finalData) => {
        if (!Array.isArray(data) || data.length === 0) return;

        // Assuming the first object contains the correct headers mapping
        if (!Array.isArray(finalData)) {
            const renamedData = data.map(obj => {
                const newObj = {};
                for (let key in obj) {
                    let finalkey = Object.keys(finalData).find(keys => finalData[keys] === key)
                    if (obj.hasOwnProperty(key) && finalkey) {
                        const newKey = finalkey;
                        newObj[newKey] = obj[key];
                    }
                }
                return newObj;
            });
            // console.log(renamedColumns)
            setData(renamedData);
            const headers = [...new Set(
                renamedData.flatMap(obj => Object.keys(obj))
            )]

            const cols = headers.map(header => ({
                accessor: header,
                Header: header,
            }));

            setColumns(cols);
            setSelectedColumns(Object.fromEntries(headers.map(col => [col, true])));
            setRenamedColumns(headers);

            setpaginatedData(paginateData(renamedData, page, 10));
            setShowData(true);


        } else {
            var invalidCount = 0;
            finalData = finalData
                .map(item => {
                    if (item.Phone) {
                        let phone = item?.Phone?.toString().trim();

                        // Always remove +91 or 0 from the start
                        phone = phone.replace(/^(\+91|0)/, '');

                        // Remove 91 if the remaining length is more than 10
                        if (phone.length > 10 && phone.startsWith('91')) {
                            phone = phone.slice(2);
                        }

                        return {
                            ...item,
                            Phone: phone
                        };
                    }

                })
                .filter(item => {
                    if(item?.Phone && /^[6-9]\d{9}$/.test(item.Phone)){
                       return /^[6-9]\d{9}$/.test(item.Phone) && item.Name
                    }else{
                        invalidCount = invalidCount + 1
                    }

                    
                });
                console.log(invalidCount)
                setInvalidCount(invalidCount)

            if (finalData.length == 0) {
                setShowData(false)
                setShowTableData(false)
                setData([])
                Popup.alert("ERROR", "Please Check Required Column Mapped Properly.", "ERROR")
                return
            }else{
                Popup.alert("All selected Data Replaced !", "Data is replaced successfully !", "SUCCESS")
            }
            // console.log(finalData)
            setData(finalData);
            const headers = [...new Set(
                finalData.flatMap(obj => Object.keys(obj))
            )]

            const cols = headers.map(header => ({
                accessor: header,
                Header: header,
            }));

            setColumns(cols);
            setSelectedColumns(Object.fromEntries(headers.map(col => [col, true])));
            setRenamedColumns(headers);

            setpaginatedData(paginateData(finalData, page, 10));
            setShowData(true);

        }




    };


    return (
        <Modal
            header={data.length == 0 ? "Upload" : showTableData ? "Preview" : "Match/Replace Columns"}
            
            open={open}
            onClose={close}
            contentStyle={{ width: data.length == 0 ? "570px" : "650px", height: data.length == 0 ? 'auto' : 'auto', borderRadius: "10px" }}
            headerContainerStyle={{ padding: data.length == 0 ?  "15px 50px" : "6px 14px",borderBottom:data.length == 0 ? null : '1px solid #bfc8d980',fontWeight:"700" }}
        >
            {data.length == 0 &&
                <>
                <DragExcelUploader onFileSelect={handleFileUpload}/>
                    {/* <div className="p-4 border rounded-lg shadow-md bg-white">
                        <div style={{ display: "grid", justifyContent: "center" }}>
                            <label style={{ fontSize: "15px", fontWeight: "500" }} className="block text-gray-700 mb-1">
                                Mandatory field: <b style={{ fontSize: "13px" }} >Name</b>,
                                <b style={{ fontSize: "13px" }} > Phone</b>.
                            </label>
                            <label style={{ fontSize: "15px", fontWeight: "500" }} className="block text-gray-700  mb-2">
                                Optional field:{" "}
                                <b style={{ fontSize: "13px" }} >State, Address, District, Taluka, Email, Source</b>.
                            </label>
                        </div>

                        <FileUploader
                            key={refresh}
                            selectedFileName={selectedFile?.name || null}
                            fileInputRef={ProfilePicRef}
                            uploaderId="profilePic"
                            placeholder="Upload File"
                            allowedFileSize={30}
                            placeholderHeight="30px"
                            onClear={() => setSelectedFile(null)}
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            onFileSelect={handleFileUpload}
                        />
                    </div> */}
                </>}

            {data.length > 0 &&
                <>

                    {(!showData && !showTableData) &&
                        <ExcelValidationForm validation={["Name","Phone"]} MandatoryColumns={[
                            "Name",
                            "Phone",
                            "Email",
                            "State",
                            "Address",
                            "District",
                            "Taluka",
                            "Source"
                          ]} renamedColumns={renamedColumns} onsubmit={(finalData) => {
                            // console.log(finalData)
                            handleExcelColumnValidation(finalData)
                            setShowData(true)
                        }
                        } />
                    }



                    {showData &&


                        <>

                            <ExcelvalueEditor datas={data} renamedColumns={renamedColumns} onSubmits={(data) => {
                                // console.log(data)
                                setShowTableData(true)
                                handleExcelColumnValidation(data)

                                setShowData(false)
                            }} />


                        </>

                    }


                    {showTableData &&

                        <>
                            <TableView
                                key={refresh}
                                showSrNo={true}
                                
                                paginationStyle={"14px 18px"}

                                onStateChange={async (changedState) => {

                                    setPage(Number(changedState.pageNumber))
                                    setpaginatedData(paginateData(data, changedState.pageNumber, 10))
                                }}
                                isLoading={false}
                                loaderHeight={"500px"}
                                columns={renamedColumns.map((col, index) => ({ accessor: col, Header: col }))}
                                data={paginatedData}
                                pageNumber={page}
                                pageSize={10}
                                count={data.length}
                            />

                            <div style={{ display: "flex", justifyContent: "space-between", marginTop: "9px",marginLeft:"10px",padding:"10px",marginRight:"15px" }}>
                                <div>{showTableData &&
                                                                    (<> 
                                                                    {invalidCount ? (
                                                                        <div style={{ display: "flex", gap: "5px" }}>
                                                                        <INFO style={{ width: "20px", height: "20px", bottom: "20px" }} />  <span style={{
                                                                              fontFamily: "Manrope",
                                                                              fontWeight: 500,
                                                                              fontSize: "14px",
                                                                              lineHeight: "100%",
                                                                              letterSpacing: "0%",
                                                                              marginTop: "3px"
                                                                          }}> Found {invalidCount} incomplete records , will be skipped.</span>
                                                                      </div>
                                                                    ) : null}
                                                                        
                                
                                                                    </>)}
                                
                                                                </div>
                                <div>


                                    <Button isDisabled={isAdding || (columnspresent == true ? true : false)} style={{ whiteSpace: "nowrap", height: "30px", marginBottom: "10px", marginRight: "5px" }} text={isAdding ? "Importing" : "Import"} onClick={() => handleSubmit()} className="btn-large" />

                                </div>
                            </div>
                        </>

                    }
                </>
            }

        </Modal>

    );
};

export default ExcelUploader;